module.exports = __webpack_public_path__ + "img/qq-music.cfd11cdd.webp";